import { Form, Select } from 'antd'
import { FC, useContext } from 'react'
import { EditableCellCtx } from '../../../../../../components/editable-cell/editable-cell'
import { useGetAdditionalJobsQuery } from '../../../../../../store/api/additional-jobs-api'

interface AdditionalJobsProps {}

const AdditionalJobs: FC<AdditionalJobsProps> = () => {
    const ctx = useContext(EditableCellCtx)
    const { data } = useGetAdditionalJobsQuery()
    const options = data?.data.map(x => ({
        value: x.documentId,
        label: x.name,
    }))

    return (
        <Form.Item name={['additional_jobs', 'set']} noStyle>
            <Select
                style={{ width: '100%' }}
                options={options}
                autoFocus
                defaultOpen
                onBlur={ctx.onBlur}
                popupMatchSelectWidth={180}
                mode={'multiple'}
            />
        </Form.Item>
    )
}

export default AdditionalJobs
